import script from "./ValidationError.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidationError.vue?vue&type=script&setup=true&lang=js"

import "./ValidationError.vue?vue&type=style&index=0&id=4819642a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4819642a"]])

export default __exports__